import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { FAMILIAS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function FamiliasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${FAMILIAS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
